import { SessionService } from 'app/core/services/session.service';
import { GlobalValidators } from 'app/core/components/common/validators';
import { DateUtils } from 'app/core/components/common/date-utils';
import { StringUtils } from 'app/core/components/common/string-utils';
import { ClassInfo } from 'app/solar/common/class';
import { ReactiveInputComponent } from 'app/shared/components/reactive-input/reactive-input.component';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChange, Type } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Observable, Subject, BehaviorSubject } from 'rxjs';

import { NotificationService } from 'app/core/services/notification.service';
import { ClassesService } from 'app/solar/common/services/classes.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { FlexibleDropdownConfig } from 'app/shared/components/flexible-dropdown/flexible-dropdown.component';
import { AddressService } from 'app/solar/common/services/address.service';
import { SmartModalService, ModalSize } from '../../../core/services/smart-modal.service';
import { PreviewCertificateComponent, PreviewCertificateModel } from 'app/shared/components/preview-certificate/preview-certificate.component';

declare var $: any;
declare var moment: any;

@Component({
    selector: 'itpx-class-info',
    templateUrl: './class-info.component.html',
    styleUrls: ['./class-info.component.css']
})
export class ClassInfoComponent extends RxComponent {

    private nextDay: any;

    private displayCertificationMessage: boolean;
    private invalidEndDate: boolean;
    private classInfo: FormGroup;
    private certificateInfo: FormGroup;
    private addressConfig: any;
    private signatoriesDict: Array<any>;
    private buyerLogoPath: string;
    private buyerName: string;
    private previewConfig: PreviewCertificateModel;
    private certificateTitle: string;
    private certificateCommentary: string;
    private certificateSignatories: Array<any>;
    private certificateSignatoriesToPreview: Array<any>;
    private formSubmitted = new Subject();
    private rawSignatories: Array<any>;
    private hasCertificate: boolean;
    private placeholderDropdown = 'Select up to 3 signatories';

    @ViewChild('startDate') startDateElement: ReactiveInputComponent;
    @ViewChild('endDate') endDateElement: ReactiveInputComponent;
    @ViewChild('releaseDate') releaseDateElement: ReactiveInputComponent;
    @ViewChild('releaseTime') releaseTimeElement: ReactiveInputComponent;
    @ViewChild('redirectEmails') redirectEmailsElement: any;
    @ViewChild('createCertificate') createCertificateElement: any;
    @ViewChild('iframeWrapper') iframeWrapperElement: any;

    @Input() private class: any;
    @Input() private config: any;
    @Input() private status: string;
    @Input() private forceVenueListRefresh: Observable<any>;
    @Input() private disabled: boolean = false;

    @Output() private formStateChange = new EventEmitter<any>();

    private timezones: Observable<any[]>;
    private isUserAdmin: boolean = false;
    private userGroups: any;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private classesService: ClassesService,
        private addressService: AddressService,
        private sessionService: SessionService,
        private modalService: SmartModalService
    ) {
        super();
    }

    ngOnInit() {

        let classData = this.getInitialClassInfo(this.class);

        this.addressConfig = this.addressService.getClassVenueFlexConfig(classData.id, this.forceVenueListRefresh);
        this.addressConfig.initialItem = classData.venueId ? { key: classData.venueId } : null;

        // this.classesService.getSignatories()
        //     .subscribe(
        //         body => {
        //             this.rawSignatories = body.data;
        //             this.signatoriesDict = this.formattedSignatories(body.data);
        //             if(this.hasCertificate) {
        //                 this.classInfo.patchValue({
        //                     configureCertificate: true
        //                 });
        //                 this.certificateInfo.patchValue({
        //                     title: this.class['certificate']['title'],
        //                     commentation: this.class['certificate']['commendation'],
        //                     signatories: this.class['certificate']['signers']
        //                 });
        //                 this.certificateSignatories = this.class['certificate']['signers'];
        //                 this.certificateSignatoriesToPreview = this.defaultSignatories(this.certificateSignatories);
        //             }
        //         }
        //     )
        // this.classesService.getBuyerDetails()
        //     .subscribe(
        //         body => {
        //             this.buyerLogoPath = body.data.brandedPortalLogo;
        //             this.buyerName = body.data.name;

        //         }
        //     )

        this.classInfo = this.fb.group({
            id: [classData.id],
            displayName: [{value: classData.displayName, disabled: this.disabled}, [Validators.required, Validators.minLength(2)]],
            startDate: [{value: classData.startDate, disabled: this.disabled}, [Validators.required]],
            endDate: [{value: classData.endDate, disabled: this.disabled}, [Validators.required]],
            virtualVenue: [{value: classData.virtualVenue, disabled: this.disabled}],
            venueId: [{ value: classData.venueId, disabled: classData.virtualVenue || this.disabled }, classData.virtualVenue ? [] : [Validators.required]],
            releaseDate: [{value: classData.releaseDate, disabled: this.disabled}, [Validators.required]],
            releaseTime: [{value:null, disabled: this.disabled}, [Validators.required]],
            timezone: [{value: classData.timezone, disabled: this.disabled}, [Validators.required]],
            redirectEmails: [{value: !!classData.redirectLearnerEmails, disabled: this.disabled}],
            redirectLearnerEmails: [{value: classData.redirectLearnerEmails, disabled: this.disabled}, [Validators.required, GlobalValidators.email]],
            configureCertificate: [{value: this.hasCertificate, disabled: this.disabled}],
            displayCertificationMessage: [{value: this.displayCertificationMessage, disabled: this.disabled}]
        });

        this.certificateInfo = this.fb.group({
            title: ['', Validators.required],
            commentation: ['', Validators.required],
            signatories: ['', Validators.required]
        });


        if (this.hasCertificate) {
            this.classInfo.patchValue({
                configureCertificate: true
            });
            this.certificateInfo.patchValue({
                title: this.class['certificate']['title'],
                commentation: this.class['certificate']['commendation'],
                signatories: this.class['certificate']['signers']
            });
            this.certificateSignatories = this.class['certificate']['signers'];
            this.certificateSignatoriesToPreview = this.defaultSignatories(this.certificateSignatories);
        }

        this.classInfo.controls.redirectEmails.valueChanges
            .startWith(this.classInfo.controls.redirectEmails.value)
            .bindToLifecycle(this)
            .subscribe(toggled => {
                if (toggled) {
                    this.classInfo.controls.redirectLearnerEmails.enable();
                    $(this.redirectEmailsElement.nativeElement).slideDown(200, 'linear');
                } else {
                    this.classInfo.controls.redirectLearnerEmails.disable();
                    $(this.redirectEmailsElement.nativeElement).slideUp(200, 'linear');
                }
            });


        // Prepopulate on initial toggle
        this.classInfo.controls.redirectEmails.valueChanges
            .take(1)
            .filter(toggled => toggled)
            .bindToLifecycle(this)
            .subscribe(_ => this.classInfo.controls.redirectLearnerEmails.setValue(this.sessionService.getUserDetails().username));

        let startDate = this.classInfo.controls.startDate.valueChanges
            .filter(d => StringUtils.notNullOrEmpty(d))
            .startWith(classData.startDate);

        let endDate = this.classInfo.controls.endDate.valueChanges
            .filter(d => StringUtils.notNullOrEmpty(d))
            .startWith(classData.endDate);

        let releaseDate = this.classInfo.controls.releaseDate.valueChanges
            .filter(d => StringUtils.notNullOrEmpty(d))
            .startWith(classData.releaseDate);

        this.classInfo.controls.virtualVenue.valueChanges
            .bindToLifecycle(this)
            .subscribe(isVirtualVenue => {
                if (isVirtualVenue) {
                    this.classInfo.controls.venueId.disable();
                    this.classInfo.controls.venueId.setValue(null);
                } else {
                    this.classInfo.controls.venueId.enable();
                }
            });

        startDate
            .map(val => new Date(val))
            .bindToLifecycle(this)
            .subscribe(startDate => {
                this.endDateElement.set('minDate', startDate);

                let maxReleaseDate = startDate;
                if (this.status == 'edit') {
                    let exams = Object.keys(this.class.exams);
                    if (exams.length > 0) {

                        let minExamDate = exams
                            .map(variantSku => this.getExamTurnAroundTimeStartDate(this.class.exams[variantSku]))
                            .reduce((d1, d2) => d1.isBefore(d2) ? d1 : d2);

                        if (moment(startDate).isAfter(minExamDate)) {
                            maxReleaseDate = minExamDate._d;
                        }
                    }
                }

                this.releaseDateElement.set('softMaxDate', maxReleaseDate);
            });

        Observable.combineLatest(
            startDate, endDate, releaseDate,
            (start, end, release) => ({ start: start, end: end, release: release })
        )
            .skip(1)
            .bindToLifecycle(this)
            .subscribe(dates => {
                if (moment(dates.start).diff(moment(dates.end), 'days') >= 1) {
                    this.classInfo.controls.endDate.setErrors({ msg: 'End date must be after start date.' });
                    this.classInfo.controls.endDate.markAsTouched();
                }

                if (moment(dates.release).isAfter(moment(dates.start))) {
                    this.classInfo.controls.releaseDate.setErrors({ msg: 'Invitations must be sent before class start.' });
                    this.classInfo.controls.releaseDate.markAsTouched();
                }
            });

        let today = moment().startOf('day')._d;
        let tomorrow = moment().startOf('day').add(1, 'days')._d;
        let now = moment()._d;
        switch (this.status) {
            case 'create':
                this.startDateElement.set('minDate', tomorrow);
                this.endDateElement.set('minDate', tomorrow);
                this.releaseDateElement.set('minDate', now);

                this.classInfo.controls.releaseTime.setValue('12:00');
                this.classesService.getDomain().take(1).subscribe( res => this.displayCertificationMessage = !!res.data.certificateDeliveryEnabled);
                break;
            case 'edit':
                this.startDateElement.set('minDate', moment(this.class.startDate)._d);
                this.endDateElement.set('minDate', moment(this.class.startDate)._d);

                let releaseTimeStr = moment(classData.releaseDate).format('HH:mm');
                this.classInfo.controls.releaseTime.setValue(releaseTimeStr);

                if (this.class.status.configKey == 'released') {
                    this.releaseDateElement.set('disabled', true);
                    this.releaseTimeElement.set('disabled', true);
                    this.classInfo.controls.timezone.disable();
                } else {
                    this.releaseDateElement.set('softMinDate', now);
                }
                this.nextDay = moment(this.classInfo.get('endDate').value).startOf('day').add(1, 'days')._d;
                if(this.class && this.class.certificate && this.class.certificate.state) {
                    this.displayCertificationMessage = this.class.certificate.state !== 'STOP'
                    if(this.class.certificate.state === 'STOP'){ //If the class is already configured it will be enabled
                        this.classesService.getDomain().take(1).subscribe( res => this.displayCertificationMessage = !!res.data.certificateDeliveryEnabled);
                    }
                }else
                    this.classesService.getDomain().take(1).subscribe( res => this.displayCertificationMessage = !!res.data.certificateDeliveryEnabled);
                break;
        }

		this.classInfo.get('endDate').statusChanges
            // .startWith(false)
            .subscribe(res => {
                this.invalidEndDate = res === 'INVALID';
                if (res === 'VALID')
                    this.nextDay = moment(this.classInfo.get('endDate').value).startOf('day').add(1, 'days').format('DD MMM YYYY');
            });
        this.timezones = this.classesService.getTimezonesDictionary()
            .map(body => body.data)
            .neverError();

        this.classInfo.statusChanges
            .bindToLifecycle(this)
            .subscribe(status =>
                this.formStateChange.emit({ valid: status == 'VALID', data: this.getFormData() })
            );

        this.classInfo.get('endDate').statusChanges.subscribe(
            res => {
                this.invalidEndDate = res === 'INVALID';
                this.nextDay = moment(this.classInfo.get('endDate').value).startOf('day').add(1, 'days')._d;
            }
        )


        this.previewConfig = {
            previewFn: (data) => this.classesService.previewCertificate(data),
            downloadFn: (data) => this.classesService.downloadCertificate(data),
            certificateTemplate: 'CLASS_COMPLETION_CERTIFICATE'
        };
        // this.certificateInfo.statusChanges
        //     .bindToLifecycle(this)
        //     .subscribe(
        //         status => {
        //             this.formStateChange.emit({ valid: (this.certificateInfo.valid && this.classInfo.valid)  , data: this.getFormData() })
        //         }
        //     )

        // this.classInfo.controls.configureCertificate.valueChanges
        //     .startWith(this.classInfo.controls.configureCertificate.value)
        //     .bindToLifecycle(this)
        //     .subscribe(change => {
        //         if(change) {
        //             $(this.createCertificateElement.nativeElement).slideDown(200, 'linear');
        //             this.formStateChange.emit({ valid: (this.certificateInfo.valid && this.classInfo.valid), data: this.getFormData() })
        //         } else {
        //             $(this.createCertificateElement.nativeElement).slideUp(200, 'linear');
        //         }
        //     }
        // )
        this.userGroups = this.sessionService.getUserGroups();

        if(this.userGroups && (this.userGroups.indexOf('administrator') != -1 || this.userGroups.indexOf('buyer-admin') != -1 )) {
            this.isUserAdmin = true;
        }
    }

    private getExamTurnAroundTimeStartDate(exam: any): any {
        return moment(exam.fulfillmentDeadlineDate).startOf('day');
    }

    private getFormData(): ClassInfo {
        let formData = this.classInfo.getRawValue();
        if (!formData.redirectEmails) formData.redirectLearnerEmails = null;
        formData.startDate = this.toLocalTime(formData.startDate);
        formData.endDate = this.toLocalTime(formData.endDate);

        let [hours, minutes] = formData.releaseTime && formData.releaseTime != '' ?
            formData.releaseTime.split(':') :
            moment(formData.releaseDate).format('HH:mm').split(':');

        formData.releaseDate = this.toLocalTime(formData.releaseDate, parseInt(hours, 10), parseInt(minutes, 10));

        if (this.classInfo.controls.configureCertificate.value) {
            formData.certificate = {
                template: 'CLASS_COMPLETION_CERTIFICATE',
                title: this.certificateInfo.controls.title.value,
                commendation: this.certificateInfo.controls.commentation.value,
                signers: this.certificateSignatories
            }
        }
        formData.displayCertificationMessage = this.displayCertificationMessage;
        formData.certificate = {
            state: formData.displayCertificationMessage ? (formData.configureCertificate ? 'AUTO' : 'MANUAL') : 'STOP'
        };
        return formData;
    }

    private getInitialClassInfo(c: any): ClassInfo {
        if (this.class && this.class.certificate && this.class.certificate.state) {
            this.hasCertificate = this.class.certificate.state === 'AUTO';
        }
        return {
            id: this.class ? this.class.id : null,
            name: this.class ? this.class.name : null,
            displayName: this.class ? this.class.displayName : null,
            startDate: this.class ? this.class.startDate : null,
            endDate: this.class ? this.class.endDate : null,
            virtualVenue: this.class ? this.class.virtualVenue : false,
            venueId: (this.class && this.class.venue) ? this.class.venue.id : null,
            releaseDate: this.class ? this.class.releaseDate : null,
            releaseTime: this.class ? this.class.releaseTime : null,
            timezone: (this.class && this.class.timezone) ? this.class.timezone : moment.tz.guess(),
            redirectLearnerEmails: this.class ? this.class.redirectLearnerEmails : null,
            certificate: null
        };
    }

    private toLocalTime(date: any, hours?: number, minutes?: number): string {
        let mDate = moment(date);
        if (hours >= 0 && minutes >= 0) {
            mDate.set({ hour: hours, minute: minutes });
        }

        return moment(mDate).utc().add(mDate.utcOffset(), 'm').format();
    }

    private formattedSignatories(signatories: Array<any>) {
        let formattedDict = [];
        signatories.forEach(el => {
            if (el.hasOwnProperty('id')) {
                formattedDict.push({
                    key: el['id'],
                    value: el['name'] + ',' + ' ' + el['designation']
                })
            }
        })
        return formattedDict
    }

    private onChangeSignatory(event: Array<any>) {

        let result = [];
        let formatteResult = [];
        event.forEach(el => {
            result.push(this.mapSignatory(el));
        });
        this.certificateSignatories = this.formatSignatoriesToSend(result);
        this.certificateSignatoriesToPreview = result;
        this.certificateInfo.patchValue({
            signatories: this.certificateSignatories
        })
    }

    private mapSignatory(signatoryId: string) {
        let signatory = {};
        if (this.rawSignatories) {
            this.rawSignatories.forEach(el => {
                if (el['id'] == signatoryId) {
                    signatory = {
                        id: el['id'],
                        name: el['name'],
                        designation: el['designation']
                    }
                }
            });
        }

        return signatory
    }
    private formatSignatoriesToSend(signatories: Array<any>) {
        let result = [];
        signatories.forEach(el => {
            if (el['id']) {
                result.push(el['id']);
            }
        });
        return result;
    }

    private onPreviewCertificate(certificateInfo: any) {
        let certificateDetails = {
            template: 'CLASS_COMPLETION_CERTIFICATE',
            extra: {
                certificate_title: this.certificateInfo.controls.title.value,
                certificate_commendation: this.certificateInfo.controls.commentation.value,
                learner_firstname: 'Atanas',
                learner_lastname: 'Rusenov',
                certificate_buyer_logo: this.buyerLogoPath,
                certificate_buyer_name: this.buyerName
            }

        }

        this.certificateSignatoriesToPreview.forEach(el => {
            if (el.hasOwnProperty('name')) {
                certificateDetails.extra['signer' + this.certificateSignatoriesToPreview.indexOf(el, 0) + '_name'] = el['name'],
                    certificateDetails.extra['signer' + this.certificateSignatoriesToPreview.indexOf(el, 0) + '_position'] = el['designation'],
                    certificateDetails.extra['signer' + this.certificateSignatoriesToPreview.indexOf(el, 0) + '_signature'] = el['name']
            }

            if (this.certificateSignatoriesToPreview.indexOf(el) === (this.certificateSignatoriesToPreview.length - 1)) {
                return this.getCertificatePreview(certificateDetails);
            }

        })


    }

    private getCertificatePreview(certificateDetails: any) {

        this.classesService.getCertificateTemplatePreview(certificateDetails).neverError()
            .map(body => body['data'])
            .bindToLifecycle(this)
            .subscribe(template => {
                let iframeDocument = document.querySelector('#certificate-holder')['contentWindow'].document;
                $(this.iframeWrapperElement.nativeElement).slideDown(200, 'linear');
                iframeDocument.open('text/html', 'replace');
                iframeDocument.write(template);
                iframeDocument.close();
                $('iframe#certificate-holder').contents().find('head')
                    .append($(`<style type="text/css">  
                        div.person{padding-top: 245px !important;}
                        .divTableCellSign0, .divTableCellSign1, .divTableCellSign2 {font-size: 80%} 
                        </style>`));

            });
    }

    private defaultSignatories(certificateSignatories: any) {
        let signatories = [];
        if (certificateSignatories) {
            certificateSignatories.forEach(el => {
                signatories.push(this.mapSignatory(el));
            })
        }
        return signatories
    }

    private onShowMeClick() {
        this.router.navigate(['/support/guides/email-customization'])
    }

    private onPreview() {
        this.modalService.open(<Type<Component>>PreviewCertificateComponent, this.previewConfig, 'Certificate Preview', ModalSize.Lg).neverError()
            .bindToLifecycle(this)
            .subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/class-info/class-info.component.ts